import React from 'react';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';

import { Orientation } from './types';

type BadgeableOrientation = Exclude<Orientation, typeof Orientation.Unknown>;

const BADGE_LABELS: Record<BadgeableOrientation, string> = {
  [Orientation.Portrait]: 'Portrait',
  [Orientation.Landscape]: 'Landscape',
  [Orientation.Square]: 'Square',
  [Orientation.Mixed]: 'Mixed',
};

export default function OrientationBadge({ orientation }: { orientation: Orientation }) {
  if (orientation === Orientation.Unknown) {
    return <span className="text-muted">Unknown</span>;
  }

  return <Badge variant="secondary">{BADGE_LABELS[orientation]}</Badge>;
}
